module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.f25bd059.ttf";